var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"icon":"","aria-label":"Authentication Button","id":"login-button"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-icon',[_vm._v("mdi-lock")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }